import React, { useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../components/MaterialBox";
import MaterialSelect from "../../components/MasterSelect";
import MaterialInput from "../../components/MaterialInput";
import { FaPeopleGroup } from "react-icons/fa6";
import MaterialButton from "../../components/MaterialButton";
import { useState } from "react";
import request, { gql } from "graphql-request";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { getVendorDetail } from "../../lib/graphQL/graphQuery";
import {
  createVendorService,
  delteVendorService,
  updateVendorServive,
} from "../../lib/appUtliz/VendorService";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useLoading } from "../../context/LodingContext";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";

// const mutation = gql`
//   mutation mutation(
//     $id: String!
//     $GSTNumber: String!
//     $legalName: String!
//     $tradeName: String!
//     $vendorCategory: String!
//     $pan: String!
//     $taxPayerType: String!
//     $dateOfRegistration: String!
//     $mail: String!
//     $address1Line1: String!
//     $address1Line2: String!
//     $country1: String!
//     $state1: String!
//     $state2: String!
//     $city1: String!
//     $city2: String!
//     $zipCode1: String!
//     $address2Line1: String!
//     $address2Line2: String!
//     $country2: String!
//     $zipCode2: String!
//   ) {
//     createVendor(
//       input: {
//         id: $id
//         GSTNumber: $GSTNumber
//         legalName: $legalName
//         tradeName: $tradeName
//         vendorCategory: $vendorCategory
//         pan: $pan
//         taxPayerType: $taxPayerType
//         dateOfRegistration: $dateOfRegistration
//         mail: $mail
//         address1Line1: $address1Line1
//         address1Line2: $address1Line2
//         country1: $country1
//         state1: $state1
//         zipCode1: $zipCode1
//         address2Line1: $address2Line1
//         address2Line2: $address2Line2
//         country2: $country2
//         city1: $city1
//         city2: $city2
//         state2: $state2
//         zipCode2: $zipCode2
//       }
//     ) {
//       Vendor {
//         id
//       }
//     }
//   }
// `;

export default function AddVendor() {
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [vendorData, setVendorData] = useState({
    // vendordetails
    id: "",
    GSTNumber: "",
    legalName: "",
    tradeName: "",
    vendorCategory: "",
    panNumber: "",
    taxPayerType: "",
    mailId: "",
    dateOfRegistration: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    alternateAddressLine1: "",
    alternateAddressLine2: "",
    alternateCountry: "",
    alternateState: "",
    alternateCity: "",
    alternateZipCode: "",

    // vendor status
    salutationStatus: "unchecked",
    GSTNumberStatus: "unchecked",
    legalNameStatus: "unchecked",
    tradeNameStatus: "unchecked",
    vendorCategoryStatus: "unchecked",
    panNumberStatus: "unchecked",
    taxPayerTypeStatus: "unchecked",
    mailIdStatus: "unchecked",
    dateOfRegistrationStatus: "unchecked",
    addressLine1Status: "unchecked",
    addressLine2Status: "unchecked",
    countryStatus: "unchecked",
    stateStatus: "unchecked",
    cityStatus: "unchecked",
    zipCodeStatus: "unchecked",
    alternateAddressLine1Status: "unchecked",
    alternateAddressLine2Status: "unchecked",
    alternateCountryStatus: "unchecked",
    alternateStateStatus: "unchecked",
    alternateCityStatus: "unchecked",
    alternateZipCodeStatus: "unchecked",
  });

  const [selectedData, setSelectedData] = useState([]);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const params = useLocation();
  const id = params.search.slice(1);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();
  useEffect(() => {

    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getVendorDetail, {
        id: id,
      });
      const v = res.getVendorDetail;

    
      setSelectedData(v);
      setVendorData({
        GSTNumber: v.GSTNumber,
        legalName: v.legalName,
        tradeName: v.tradeName,
        vendorCategory: v.vendorCategory,
        panNumber: v.pan,
        taxPayerType: v.taxpayerType,
        mailId: v.mailId,
        dateOfRegistration: v.dateOfRegistration,
        addressLine1: v.address1Line1,
        addressLine2: v.address1Line2,
        country: v.country1,
        state: v.state1,
        city: v.city1,
        zipCode: v.zipCode1,
        alternateAddressLine1: v.address2Line1,
        alternateAddressLine2: v.address2Line2,
        alternateCountry: v.country2,
        alternateState: v.state2,
        alternateCity: v.city2,
        alternateZipCode: v.zipCode2,

        // customer status
        salutationStatus: "success",
        GSTNumberStatus: "success",
        legalNameStatus: "success",
        tradeNameStatus: "success",
        vendorCategoryStatus: "success",
        panNumberStatus: "success",
        taxPayerTypeStatus: "success",
        mailIdStatus: "success",
        dateOfRegistrationStatus: "success",
        addressLine1Status: "success",
        addressLine2Status: "success",
        countryStatus: "success",
        stateStatus: "success",
        cityStatus: "success",
        zipCodeStatus: "success",
        alternateAddressLine1Status: "success",
        alternateAddressLine2Status: "success",
        alternateCountryStatus: "success",
        alternateStateStatus: "success",
        alternateCityStatus: "success",
        alternateZipCodeStatus: "success",
      });
    } catch (err) {
      console.error(err.message);
    }
  };
  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setVendorData({
      GSTNumber: selectedData?.GSTNumber,
      legalName: selectedData?.legalName,
      tradeName: selectedData?.tradeName,
      vendorCategory: selectedData?.vendorCategory,
      panNumber: selectedData.pan,
      taxPayerType: selectedData.taxpayerType,
      mailId: selectedData.mailId,
      dateOfRegistration: selectedData.dateOfRegistration,
      addressLine1: selectedData.address1Line1,
      addressLine2: selectedData.address2Line1,
      country: selectedData.country1,
      state: selectedData.state1,
      city: selectedData.city1,
      zipCode: selectedData.zipCode1,
      alternateAddressLine1: selectedData.address1Line2,
      alternateAddressLine2: selectedData.address2Line2,
      alternateCountry: selectedData.country2,
      alternateState: selectedData.state2,
      alternateCity: selectedData.city2,
      alternateZipCode: selectedData.zipCode2,

      salutationStatus: "success",
      GSTNumberStatus: "success",
      legalNameStatus: "success",
      tradeNameStatus: "success",
      vendorCategoryStatus: "success",
      panNumberStatus: "success",
      taxPayerTypeStatus: "success",
      mailIdStatus: "success",
      dateOfRegistrationStatus: "success",
      addressLine1Status: "success",
      addressLine2Status: "success",
      countryStatus: "success",
      stateStatus: "success",
      cityStatus: "success",
      zipCodeStatus: "success",
      alternateAddressLine1Status: "success",
      alternateAddressLine2Status: "success",
      alternateCountryStatus: "success",
      alternateStateStatus: "success",
      alternateCityStatus: "success",
      alternateZipCodeStatus: "success",
    });
  };
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handleVendorData = (event, selectEvent) => {
    let vendorState = { ...vendorData };
    const changeAllowed = true;
    switch (event.target.name) {
      case "GSTNumber":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Z0-9]{15})$");
          if (
            alphaNLenghthRegex.test(event.target.value?.trim().toUpperCase())
          ) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "legalName":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,25})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "tradeName":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "vendorCategory":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "panNumber":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Z0-9]{10})$");
          if (
            alphaNLenghthRegex.test(event.target.value?.trim().toUpperCase())
          ) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "taxPayerType":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z]{1,20})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "mailId":
        {
          const alphaNLenghthRegex = new RegExp(
            /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
          );
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "dateOfRegistration":
        {
          const alphaNLenghthRegex = new RegExp(
            "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
          );
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "addressLine1":
        {
          const alphaNLenghthRegex = new RegExp("^.{1,150}$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "addressLine2":
        {
          const alphaNLenghthRegex = new RegExp("^.{1,150}$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "country":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "state":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "city":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "zipCode":
        {
          const alphaNLenghthRegex = new RegExp("^([ A-Za-z0-9]{6})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "alternateAddressLine1":
        {
          const alphaNLenghthRegex = new RegExp("^.{1,150}$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "alternateAddressLine2":
        {
          const alphaNLenghthRegex = new RegExp("^.{1,150}$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "alternateCountry":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "alternateState":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "alternateCity":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "alternateZipCode":
        {
          const alphaNLenghthRegex = new RegExp("^([ A-Za-z0-9]{6})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            vendorState[event.target.name + "Status"] = "success";
          } else {
            vendorState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
    }
    if (changeAllowed) {
      vendorState[event.target.name] = event.target.value;
    }
    setVendorData(vendorState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      (vendorData.GSTNumberStatus === "success" ||
        vendorData.GSTNumberStatus === "unchecked") &&
      vendorData.legalNameStatus === "success" &&
      (vendorData.tradeNameStatus === "success" ||
        vendorData.tradeNameStatus == "unchecked") &&
      vendorData.vendorCategoryStatus === "success" &&
      (vendorData.panNumberStatus === "success" ||
        vendorData.panNumberStatus == "unchecked") &&
      vendorData.taxPayerTypeStatus === "success" &&
      vendorData.mailIdStatus === "success" &&
      (vendorData.dateOfRegistrationStatus === "success" ||
      vendorData.dateOfRegistrationStatus == "unchecked") &&
      vendorData.addressLine1Status === "success" &&
      vendorData.countryStatus === "success" &&
      vendorData.stateStatus === "success" &&
      vendorData.cityStatus === "success" &&
      vendorData.zipCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddVendorData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        const values = {
          id: currentUser?.id,
          GSTNumber: vendorData.GSTNumber,
          legalName: vendorData.legalName,
          tradeName: vendorData.tradeName,
          vendorCategory: vendorData.vendorCategory,
          pan: vendorData.panNumber,
          taxPayerType: vendorData.taxPayerType,
          dateOfRegistration: vendorData.dateOfRegistration,
          mail: vendorData.mailId,
          address1Line1: vendorData.addressLine1,
          address1Line2: vendorData.addressLine2,
          country1: vendorData.country,
          state1: vendorData.state,
          city1: vendorData.city,
          zipCode1: vendorData.zipCode,
          address2Line1: vendorData.alternateAddressLine1,
          address2Line2: vendorData.alternateAddressLine2,
          state2: vendorData.alternateState,
          city2: vendorData.alternateCity,
          country2: vendorData.alternateCountry,
          zipCode2: vendorData.alternateZipCode,
        };

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });

        setCirleLoading(true);

        const createStatus = await createVendorService(values);
        setCirleLoading(false);
        if (createStatus) {
          // setConfirmationDialog({
          //   open: true,
          //   title: "Vendor Created Successfully",
          //   message: "",
          //   showCancel: true,
          //   showConfirm: true,
          //   customSection: null,
          //   onConfirm: () => {
          //     setVendorData({
          //       // vendordetails
          //       id: "",
          //       GSTNumber: "",
          //       legalName: "",
          //       tradeName: "",
          //       vendorCategory: "",
          //       panNumber: "",
          //       taxPayerType: "",
          //       mailId: "",
          //       dateOfRegistration: "",
          //       addressLine1: "",
          //       addressLine2: "",
          //       country: "",
          //       state: "",
          //       city: "",
          //       zipCode: "",
          //       alternateAddressLine1: "",
          //       alternateAddressLine2: "",
          //       alternateCountry: "",
          //       alternateState: "",
          //       alternateCity: "",
          //       alternateZipCode: "",
          //       // vendor status
          //       salutationStatus: "unchecked",
          //       GSTNumberStatus: "unchecked",
          //       legalNameStatus: "unchecked",
          //       tradeNameStatus: "unchecked",
          //       vendorCategoryStatus: "unchecked",
          //       panNumberStatus: "unchecked",
          //       taxPayerTypeStatus: "unchecked",
          //       mailIdStatus: "unchecked",
          //       dateOfRegistrationStatus: "unchecked",
          //       addressLine1Status: "unchecked",
          //       addressLine2Status: "unchecked",
          //       countryStatus: "unchecked",
          //       stateStatus: "unchecked",
          //       cityStatus: "unchecked",
          //       zipCodeStatus: "unchecked",
          //       alternateAddressLine1Status: "unchecked",
          //       alternateAddressLine2Status: "unchecked",
          //       alternateCountryStatus: "unchecked",
          //       alternateStateStatus: "unchecked",
          //       alternateCityStatus: "unchecked",
          //       alternateZipCodeStatus: "unchecked",
          //     });
          //     setConfirmationDialog({
          //       ...confirmationDialog,
          //       open: false,
          //     });
          //   },
          //   onCancel: () => {
          //     navigate("/vendor-management");
          //   },
          //   done: "Add New Vendor",
          //   back: "Back to Vendor Table",
          // });
          //navigate("/vendor-management");
          setSuccessStatus(true);
          setSucessTitle("Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/vendor");
          }, 1000);
        } else if (!createStatus) {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleCancelVendorData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/vendor");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleEditVendorData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        const values = {
          // user: currentUser?.id,
          GSTNumber: vendorData.GSTNumber,
          legalName: vendorData.legalName,
          tradeName: vendorData.tradeName,
          vendorCategory: vendorData.vendorCategory,
          pan: vendorData.panNumber,
          taxPayerType: vendorData.taxPayerType,
          dateOfRegistration: vendorData.dateOfRegistration,
          mail: vendorData.mailId,
          address1Line1: vendorData.addressLine1,
          address1Line2: vendorData.addressLine2,
          country1: vendorData.country,
          state1: vendorData.state,
          city1: vendorData.city,
          zipCode1: vendorData.zipCode,
          address2Line1: vendorData.alternateAddressLine1,
          address2Line2: vendorData.alternateAddressLine2,
          state2: vendorData.alternateState,
          city2: vendorData.alternateCity,
          country2: vendorData.alternateCountry,
          zipCode2: vendorData.alternateZipCode,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);

        const updateStatus = await updateVendorServive(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/vendor");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleDelteVendorData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const delteStatus = await delteVendorService(id);
        setCirleLoading(false);

        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/vendor");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Vendor details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="contained"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="contained"
                      color="dark"
                      onClick={handleDelteVendorData}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add Vendor Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1}>
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Vendor Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    GST Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="GSTNumber"
                  placeholder="eg. 22AAAAA0000A1Z5"
                  value={vendorData.GSTNumber.toUpperCase()}
                  onChange={handleVendorData}
                  error={vendorData.GSTNumberStatus === "error" ? true : false}
                  success={
                    vendorData.GSTNumberStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.GSTNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      GST Number should be maximum 15 characters along with
                      state code
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Vendor Legal Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="legalName"
                  placeholder="eg. Ajith"
                  value={vendorData.legalName}
                  onChange={handleVendorData}
                  error={vendorData.legalNameStatus === "error" ? true : false}
                  success={
                    vendorData.legalNameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.legalNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Legal Name should be min 2 max 25 characters long and can
                      contain only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Trade Name 
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="tradeName"
                  placeholder="Enter Trade Name "
                  value={vendorData.tradeName}
                  onChange={handleVendorData}
                  error={vendorData.tradeNameStatus === "error" ? true : false}
                  success={
                    vendorData.tradeNameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.tradeNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      trade Name should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Vendor Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="vendorCategory"
                  placeholder="eg. Vendor Category"
                  value={vendorData.vendorCategory}
                  onChange={handleVendorData}
                  error={
                    vendorData.vendorCategoryStatus === "error" ? true : false
                  }
                  success={
                    vendorData.vendorCategoryStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.vendorCategoryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Vendor Category should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    PAN Number 
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="panNumber"
                  placeholder="eg. CTLPM1947J"
                  value={vendorData.panNumber.toUpperCase()}
                  onChange={handleVendorData}
                  error={vendorData.panNumberStatus === "error" ? true : false}
                  success={
                    vendorData.panNumberStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.panNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      PAN Number should be maximum 10 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    TAX Payer Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="taxPayerType"
                  placeholder="eg. Buyer, Seller,..."
                  value={vendorData.taxPayerType}
                  onChange={handleVendorData}
                  error={
                    vendorData.taxPayerTypeStatus === "error" ? true : false
                  }
                  success={
                    vendorData.taxPayerTypeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.taxPayerTypeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Tax Payer Type should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    MailID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="mailId"
                  placeholder="eg. email123@gmail.com"
                  value={vendorData.mailId}
                  onChange={handleVendorData}
                  error={vendorData.mailIdStatus === "error" ? true : false}
                  success={vendorData.mailIdStatus === "success" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.mailIdStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Email Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date Of Registration 
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="dateOfRegistration"
                  type="date"
                  placeholder="eg. 01-01-2024"
                  value={vendorData.dateOfRegistration}
                  onChange={handleVendorData}
                  error={
                    vendorData.dateOfRegistrationStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    vendorData.dateOfRegistrationStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.dateOfRegistrationStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <Divider />
          <Stack direction="row" spacing={1}>
            <FaPeopleGroup style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Vendor Address:
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address Line 1 <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="addressLine1"
                  placeholder="eg. DoorNo,Street.."
                  value={vendorData.addressLine1}
                  onChange={handleVendorData}
                  error={
                    vendorData.addressLine1Status === "error" ? true : false
                  }
                  success={
                    vendorData.addressLine1Status === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.addressLine1Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address Line 2  <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="addressLine2"
                  placeholder="eg. Landmark,Area"
                  value={vendorData.addressLine2}
                  onChange={handleVendorData}
                  error={
                    vendorData.addressLine2Status === "error" ? true : false
                  }
                  success={
                    vendorData.addressLine2Status === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.addressLine2Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Country <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="country"
                  placeholder="eg. India"
                  value={vendorData.country}
                  onChange={handleVendorData}
                  error={vendorData.countryStatus === "error" ? true : false}
                  success={
                    vendorData.countryStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.countryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter your Country</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    State <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="state"
                  placeholder="eg. Tamil Nadu"
                  value={vendorData.state}
                  onChange={handleVendorData}
                  error={vendorData.stateStatus === "error" ? true : false}
                  success={vendorData.stateStatus === "success" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.stateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter Your State</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    City <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="city"
                  placeholder="eg. Chennai"
                  value={vendorData.city}
                  onChange={handleVendorData}
                  error={vendorData.cityStatus === "error" ? true : false}
                  success={vendorData.cityStatus === "success" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.cityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter Your City</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Zip Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="zipCode"
                  placeholder="eg. 600001"
                  value={vendorData.zipCode}
                  onChange={handleVendorData}
                  error={vendorData.zipCodeStatus === "error" ? true : false}
                  success={
                    vendorData.zipCodeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.zipCodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Zipcode with maximum 6 numbers
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <Divider />
          <Stack direction="row" spacing={1}>
            <FaPeopleGroup style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Vendor Alternate Address :
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Alternate Address Line 1
                    
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateAddressLine1"
                  placeholder="eg. DoorNo,Street.."
                  value={vendorData.alternateAddressLine1}
                  onChange={handleVendorData}
                  error={
                    vendorData.alternateAddressLine1Status === "error"
                      ? true
                      : false
                  }
                  success={
                    vendorData.alternateAddressLine1Status === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.alternateAddressLine1Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Your Valid Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Alternate Address Line 2
                    
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateAddressLine2"
                  placeholder="eg. Landmark,Area"
                  value={vendorData.alternateAddressLine2}
                  onChange={handleVendorData}
                  error={
                    vendorData.alternateAddressLine2Status === "error"
                      ? true
                      : false
                  }
                  success={
                    vendorData.alternateAddressLine2Status === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.alternateAddressLine2Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Your Valid Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Alternate Country
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateCountry"
                  placeholder="eg. United States"
                  value={vendorData.alternateCountry}
                  onChange={handleVendorData}
                  error={
                    vendorData.alternateCountryStatus === "error" ? true : false
                  }
                  success={
                    vendorData.alternateCountryStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.alternateCountryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Your Alternate Country
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Alternate State
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateState"
                  placeholder="eg. Kerala"
                  value={vendorData.alternateState}
                  onChange={handleVendorData}
                  error={
                    vendorData.alternateStateStatus === "error" ? true : false
                  }
                  success={
                    vendorData.alternateStateStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.alternateStateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Your Alternate State
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Alternate City
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateCity"
                  placeholder="eg. Pondicherry"
                  value={vendorData.alternateCity}
                  onChange={handleVendorData}
                  error={
                    vendorData.alternateCityStatus === "error" ? true : false
                  }
                  success={
                    vendorData.alternateCityStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.alternateCityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter Your City</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Alternate Zip Code
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateZipCode"
                  placeholder="eg. 600002"
                  value={vendorData.alternateZipCode}
                  onChange={handleVendorData}
                  error={
                    vendorData.alternateZipCodeStatus === "error" ? true : false
                  }
                  success={
                    vendorData.alternateZipCodeStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {vendorData.alternateZipCodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Zipcode with maximum 6 numbers
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleEditVendorData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddVendorData}
                >
                  Submit
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleCancelVendorData}
                >
                  Cancel
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
